export const DISPLAY_AAST_POINT = 'zone.DISPLAY_AAST_POINT';

export const displayPoint = point => ({
  type: DISPLAY_AAST_POINT,
  point,
});



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/actions/points.js